// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container {
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.page-vertical-spacing {
  margin: 80px auto;
}

.grid-gutter-spacing {
  grid-row-gap: 0 !important;
}

.bold-text {
  font-weight: bold !important;
}

.heading-color {
  color: var(--fds-color--gray3) !important;
}

.show {
  display: block;
}

.hidden {
  display: none;
}

.z-index-0 {
  z-index: 0;
}

.dropdown-width {
  width: 90px !important;
  padding-top: 0 !important;
}

.btn-styles > button {
  opacity: 50%;
}

.btn-styles > button > span {
  border-radius: 25px;
  background-color: var(--fds-color--gray1);
  color: var(--fds-color--primary) !important;
  box-shadow: rgb(38, 57, 77) 0 20px 30px -10px;
}

.border-style {
  box-shadow: 1px 4px 10px 0 rgba(156, 156, 156, 0.5);
  border-radius: 3px;
}

.product-detail-card-container {
  height: 100%;
  background-color: var(--fds-color--white);
}

.success-msg-container {
  max-width: 1120px;
}

.contact-links {
  text-decoration: none !important;
}

.fordpay-checkout-container > fordpay-checkout > section > div {
  margin-bottom: 0 !important;
}

.fds-font--ford-icons__chevron-filled-right::before {
  content: "\\e91a" !important;
}

@media screen and (max-width: 1023px) {
  .breadcrumbs,
  .breadcrumbs-separator,
  .price-summary-label {
    display: none;
  }
  .page-vertical-spacing {
    margin: 64px auto;
  }
}
/* Mobile */
@media screen and (max-width: 599px) {
  .dropdown-width {
    width: 70px !important;
  }
  .page-vertical-spacing {
    margin: 40px auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,yCAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,sBAAA;EACA,yBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,mBAAA;EACA,yCAAA;EACA,2CAAA;EACA,6CAAA;AACF;;AAEA;EACE,mDAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,yCAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE;;;IAGE,aAAA;EACF;EAEA;IACE,iBAAA;EAAF;AACF;AAGA,WAAA;AACA;EACE;IACE,sBAAA;EADF;EAIA;IACE,iBAAA;EAFF;AACF","sourcesContent":[".page-container {\n  max-width: 1440px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n}\n\n.page-vertical-spacing {\n  margin: 80px auto;\n}\n\n.grid-gutter-spacing {\n  grid-row-gap: 0 !important;\n}\n\n.bold-text {\n  font-weight: bold !important;\n}\n\n.heading-color {\n  color: var(--fds-color--gray3) !important;\n}\n\n.show {\n  display: block;\n}\n\n.hidden {\n  display: none;\n}\n\n.z-index-0 {\n  z-index: 0;\n}\n\n.dropdown-width {\n  width: 90px !important;\n  padding-top: 0 !important;\n}\n\n.btn-styles > button {\n  opacity: 50%;\n}\n\n.btn-styles > button > span {\n  border-radius: 25px;\n  background-color: var(--fds-color--gray1);\n  color: var(--fds-color--primary) !important;\n  box-shadow: rgb(38, 57, 77) 0 20px 30px -10px;\n}\n\n.border-style {\n  box-shadow: 1px 4px 10px 0 rgb(156 156 156 / 50%);\n  border-radius: 3px;\n}\n\n.product-detail-card-container {\n  height: 100%;\n  background-color: var(--fds-color--white);\n}\n\n.success-msg-container {\n  max-width: 1120px;\n}\n\n.contact-links {\n  text-decoration: none !important;\n}\n\n.fordpay-checkout-container > fordpay-checkout > section > div {\n  margin-bottom: 0 !important;\n}\n\n.fds-font--ford-icons__chevron-filled-right::before {\n  content: '\\e91a' !important;\n}\n\n@media screen and (max-width: 1023px) {\n  .breadcrumbs,\n  .breadcrumbs-separator,\n  .price-summary-label {\n    display: none;\n  }\n\n  .page-vertical-spacing {\n    margin: 64px auto;\n  }\n}\n\n/* Mobile */\n@media screen and (max-width: 599px) {\n  .dropdown-width {\n    width: 70px !important;\n  }\n\n  .page-vertical-spacing {\n    margin: 40px auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
